export default __webpack_public_path__ + "static/media/danger@3x.783bbbcd.jpg";